export function setCachearticlesLoading (state, loading = false) {
  state.cachearticlesLoading = loading
}

export function setCachearticles (state, cachearticles) {
  if (cachearticles && cachearticles.data) {
    state.cachearticles = cachearticles.data
    state.cachearticlesCurrentPage = cachearticles.current_page
    state.cachearticlesLastPage = cachearticles.last_page
    state.cachearticlesPerPage = cachearticles.per_page
    state.cachearticlesTotal = cachearticles.total
  } else if (cachearticles && Array.isArray(cachearticles)) {
    state.cachearticles = cachearticles
    state.cachearticlesCurrentPage = 1
    state.cachearticlesLastPage = 1
    state.cachearticlesPerPage = 100
    state.cachearticlesTotal = cachearticles.length
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
